import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductApprovalsBulkActionSendRequestEntityParams {
  selectedProducts: number[];
  action: string;
}
export class ProductApprovalsBulkActionSendRequestEntity extends BaseEntityClass {
  selected_products: number[];
  action: string;
  constructor(params: ProductApprovalsBulkActionSendRequestEntityParams) {
    super();
    this.type = "product_approvals_bulk_actions_send_request";
    this.entity_version = 2;
    this.selected_products = params.selectedProducts;
    this.action = params.action;
  }
}
